import React from 'react'
import WeddingSection from './WeddingSection'
import WeddingAlbum from 'components/WeddingAlbum'

export default function WeddingAlbumSection() {
  return (
    <WeddingSection>
        <div 
            className='no-wedding-padding-x no-wedding-padding-y'
        >
            <div 
                style={{
                height: "40px",
                backgroundColor: "rgb(28, 24, 16)",
                // backgroundColor: "rgb(48, 8, 8)",
                width: "100%",
                position: "relative",
            }}>
                {/* <div
                    style={{
                        position: "absolute",
                        color: "rgb(255, 252, 214)",
                        fontFamily: "'Birthstone',cursive",
                        // fontFamily: "'Gowun Dodum', sans-serif",
                        // fontStyle: "italic",
                        letterSpacing: "2px",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: "40px"
                    }}>
                    Wedding Album
                </div> */}
            </div>
            <WeddingAlbum/>
        </div>
    </WeddingSection>
  )
}
